import { createContext, ReactElement } from 'react'
import { useQuery } from 'react-query'

import { fetchGeoInfo } from '@/utils/apis/helper'

interface LanguageContextValues {
  isoCode?: string,
  geoData?: {
    info: object,
    lang: string,
    country: {
      geonameId: string,
      isoCode: string,
      names: object,
    }
  }
}

export const LanguageContext = createContext({} as LanguageContextValues)

function Provider({ children }: HocProps): ReactElement {
  const { data } = useQuery('fetchGeoData', fetchGeoInfo, { refetchOnWindowFocus: false })

  const contextValues = {
    geoData: data,
    isoCode: data?.country?.isoCode,
  }

  return (
    <LanguageContext.Provider value={contextValues}>
      {children}
    </LanguageContext.Provider>
  )
}

export default Provider
